/**
 * SEPA Payment Script
 */

(function() {
    'use strict';

    const PAYMENT_MONITOR_PREFIX = '[PaymentMonitoring:SEPA] ';

    function logPaymentEvent(eventType, details) {
        const message = PAYMENT_MONITOR_PREFIX + eventType + ' | ' + JSON.stringify(details);
        console.warn(message);
    }

    function logApiFailure(apiName, status, error, details) {
        logPaymentEvent('API_FAILURE', {
            api: apiName,
            httpStatus: status,
            error: error,
            ...details
        });
    }

    window.sepaPaymentMonitoring = {
        logPaymentEvent,
        logApiFailure
    };

})();

var SepaPayment = (function () {

    function setBankName(value) {
        var queryParams = {
            bic: value
        };

        var startTime = Date.now();

        $.ajax({
            type: 'GET',
            url: "/payment/sepa",
            data: queryParams
        }).done(function (data) {
            $("#sepaBankName").html(data);
            $("#inputBankName").val(data);
            $("#sepaBankNamePlaceholder").hide();
        }).fail(function (xhr, status, error) {
            if (window.sepaPaymentMonitoring) {
                window.sepaPaymentMonitoring.logApiFailure('getBankName', xhr.status, error, {
                    bic: value,
                    executionTimeMs: Date.now() - startTime
                });
            }

            $("#sepaBankName").html("");
            $("#inputBankName").val("");
            $("#sepaBankNamePlaceholder").show();
        });
    }

    function initialize() {
        var sepaBicInput = $("#sepaBic");
        var sepaBicValue = sepaBicInput.val();
        if (sepaBicValue) {
            setBankName(sepaBicValue);
        }

        sepaBicInput.on("blur", function () {
            setBankName(this.value);
        });
    }

    return {
        initialize: initialize
    }

})();


$(document).ready(function () {
    SepaPayment.initialize();
});